const segment=(prefix,entity)=>entity?`${prefix}${entity}`:"";export function bem(block,element,modifier){return segment("ovpn-",block)+segment("__",element)+segment("--",modifier)}
//# sourceMappingURL=bem.js.map